<template>
  <div v-if="email" class="base-email" :class="size">
    <span class="email">{{ email }}</span>
    <BaseButton
      class="copy-button"
      kind="auxiliary"
      tooltip="Copy email"
      tooltip-display="always"
      @click.stop="copyEmail"
    >
      <template #icon>
        <DuplicateIcon class="copy-icon" />
      </template>
    </BaseButton>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, toRefs } from "vue";

import { copy } from "@/clipboard";
import BaseButton from "@/components/base/BaseButton.vue";
import DuplicateIcon from "@/components/icons/DuplicateIcon.vue";
import * as inject from "@/components/inject";

export default defineComponent({
  components: {
    DuplicateIcon,
    BaseButton,
  },
  props: {
    email: {
      type: String,
      required: false,
    },
    size: {
      type: String as PropType<"default" | "small">,
      default: "default",
    },
  },
  setup(props) {
    const { email } = toRefs(props);
    const controller = inject.controller();
    const copyEmail = async () => {
      if (email.value) {
        await copy(email.value);
        controller.notifications.notify(`${email.value} copied to clipboard`);
      }
    };
    return { copyEmail };
  },
});
</script>
<style lang="scss" scoped>
.base-email {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  width: 100%;
  @include transition(display 100ms ease-in);

  .email {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &:hover .copy-icon {
    display: flex;
    flex-shrink: 0;
  }

  .copy-button {
    padding: 2px !important;
  }

  :deep(.copy-icon) {
    display: none;
    width: 12px;
    height: 12px;
    padding: 2px !important;
  }

  :deep(.copy-icon svg) {
    width: 12px;
    height: 12px;
  }

  :deep(.copy-icon svg path) {
    @include transition(fill 100ms ease);
    @include themed() {
      stroke: t($grey-40);
    }
  }

  &.small {
    @extend %font-small-regular;
    @include themed() {
      color: t($grey-40);
    }
  }
}
</style>
